<template>
<v-dialog v-model="open" scrollable persistent>
  <v-card v-if="open">
    <v-card-title class="px-4">
      <v-text-field v-model="search_term" v-debounce:1s="getUserList" class="pb-1" label="Buscar usuário" outlined hide-details></v-text-field>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <div v-if="loading" style="overflow: hidden; height: 90px">
        <v-progress-circular class="mt-3" color="#777" indeterminate></v-progress-circular>
      </div>
      <div v-if="!loading && list.length === 0" style="overflow: hidden; height: 90px; text-align: center;">
        <v-icon class="mt-5 mb-1" size="40">
          mdi-magnify
        </v-icon><br />
        <span>Utilize o campo acima para pesquisar</span>
      </div>
      <v-radio-group v-if="!loading && list.length > 0" v-model="selected" column hide-details>
        <v-radio v-for="client in list" :key="client.id" :label="client.name" :value="client.id"></v-radio>
      </v-radio-group>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn text @click="closeDialog()">
        Cancelar
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" depressed @click="closeDialog()">
        Selecionar
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  props: {
    open: Boolean,
  },
  data: () => ({
    loading: false,
    search_term: null,
    list: [],
    selected: null,
  }),
  methods: {
    closeDialog() {
      const selected = this.list.find((responsible) => responsible.id === this.selected);
      this.$emit('close-dialog', {
        entity: 'responsible',
        data: selected,
      });
    },
    getUserList() {
      const self = this;
      if (!self.search_term || self.search_term.length === 0) {
        return;
      }
      self.loading = true;
      self.$http.get('/users/organization', {
        params: {
          name: self.search_term,
          size: 10,
        },
      }).then((response) => {
        self.list = response.data.rows;
        self.loading = false;
      }).catch(() => {
        self.loading = false;
      });
    },
  },
  watch: {
    search_term: {
      handler(term) {
        if (!term || term.length === 0) {
          this.list = [];
        }
      },
    },
  },
};
</script>
